<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
          <h1>Lead Campanha de Divulgação</h1>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="Nome" label-for="name">
              <b-form-input id="name" v-model="form.name" type="text" readonly></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group label="Email" label-for="email">
              <b-form-input id="email" v-model="form.email" type="text" readonly></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="Telefone" label-for="phone">
              <b-form-input id="phone" v-model="form.phone" type="text" readonly></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group label="Colaborador de qual empresa do Grupo Rodonaves:" label-for="employee_of_which_company">
              <b-form-input id="employee_of_which_company" v-model="form.employee_of_which_company" type="text" readonly></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="Unidade" label-for="unit">
              <b-form-input id="unit" v-model="form.unit" type="text" readonly></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group label="Matrícula" label-for="registration">
              <b-form-input id="registration" v-model="form.registration" type="text" readonly></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <b-form-group label="Seguro pelo qual tenho interesse" label-for="insurance_im_interested">
              <b-form-input id="insurance_im_interested" v-model="form.insurance_im_interested" type="text" readonly></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group label="Qual a corretora que cuida dos seus sonhos?" label-for="best_broker">
              <b-form-input id="best_broker" v-model="form.best_broker" type="text" readonly></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Campaign',
    props: {
      form: {
        type: [Object],
        required: true
      },
      submitted: {
        type: Boolean,
        default: false
      },
      instance: {
        type: Object,
        default () {
          return {
            media: []
          }
        }
      },
      http: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        empty: {
        }
      }
    },

    methods: {
      title () {
        this.$forceUpdate()
      }
    },

    created () {
      const self = this
      self.form.withData(self.instance.id ? self.instance : self.empty)
        .setInitialValues(self.instance.id ? self.instance : self.empty)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/forms/Rte/Campaign.vue